import React, {useContext, useEffect, useState} from "react";
import ListComponent from "../components/ListComponent";
import {
  Col,
  Container,
  Form,
  FormCheck,
  FormControl,
  FormLabel,
  FormSelect,
  InputGroup,
  Row,
  ToggleButton,
  ToggleButtonGroup,
} from "react-bootstrap";
import DatePicker from "react-datepicker";

import {deleteCompany, getAllCompanies, registerCompany, updateCompany,} from "../API/companyApi";
import {toast} from "react-toastify";
import messageFromError from "../utils/errorUtils";
import {faEdit, faTrashCan, faUser} from "@fortawesome/free-solid-svg-icons";
import ActionModal from "../components/Modals/ActionModals/ActionModal";
import MenuItem from "../components/core/Components/Menu/MenuItem";
import MenuPopoverWrapper from "../components/MenuPopoverWrapper";
import {SalvoContext} from "../contexts/SalvoContext";
import {useTranslation} from "react-i18next";
import Menu from "../components/core/Components/Menu/Menu";
import Select from "react-select";

const CompaniesPage = () => {
  const [companies, setCompanies] = useState([]);
  const [bundles, setBundles] = useState([]);
  const [localBundles, setLocalBundles] = useState([]); // These won't have IDs

  const [showCreateCompany, setShowCreateCompany] = useState(false);
  const [showChangeNameModal, setShowChangeNameModal] = useState(false);

  const [companyName, setCompanyName] = useState("");
  const [billingEnabled, setBillingEnabled] = useState(false);
  const [autoRenew, setAutoRenew] = useState(false);
  const [autoRenewThreshold, setAutoRenewThreshold] = useState();
  const [baseConsumption, setBaseConsumption] = useState();
  const [initialCredits, setInitialCredits] = useState();
  const [trialCredits, setTrialCredits] = useState();
  const [trialEndDate, setTrialEndDate] = useState();
  const [maxMsisdns, setMaxMsisdns] = useState();
  const [defaultBundleId, setDefaultBundleId] = useState(null);
  const [bundleIds, setBundleIds] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(false);
  const [newBundleCredits, setNewBundleCredits] = useState("");
  const [newNote, setNewNote] = useState("");
  const [mode, setMode] = useState("default");

  const [action, setAction] = useState("");
  const { setSelectedCompany: setViewAsCompany } = useContext(SalvoContext);

  const { t } = useTranslation();

  useEffect(() => {
    fetchCompanies();
  }, []);

  async function fetchCompanies() {
    try {
      const response = await getAllCompanies();
      setCompanies(response.data);
    } catch (e) {
      toast.error(messageFromError(e));
    }
  }

  async function createCompany() {
    const payload = {
      name: companyName,
    };
    if (mode === "regular") {
      payload.billing = {
        enabled: true,
        autoRenew,
        autoRenewThreshold,
        initialCredits: trialCredits,
        baseConsumption,
        defaultBundleIndex: defaultBundleId,
        bundles: localBundles.map((b, idx) => ({
          amount: b.amount,
          active: bundleIds.includes(idx),
          ...(b.note ? { note: b.note } : {}),
        })),
      };
    } else if (mode === "trial") {
      payload.trial = {
        endDate: trialEndDate?.toISOString(),
        remainingCredits: trialCredits,
        maxMsisdns: maxMsisdns,
      };
    }

    try {
      await registerCompany(payload);
    } catch (e) {
      toast.error(messageFromError(e));
    }
  }

  async function updateName() {
    await updateCompany(selectedCompany.id, { name: companyName });
    toast.success("Updated");
    await fetchCompanies();
  }

  async function onDeleteCompany() {
    await deleteCompany(selectedCompany.id);
  }

  //TODO - Move to PopoverWrapper
  const [visiblePopover, setVisiblePopover] = useState(null);

  function handleToggle(i) {
    if (visiblePopover && visiblePopover === i) {
      setVisiblePopover(null);
    } else {
      setVisiblePopover(i);
    }
  }

  const bundleOptions = localBundles.map((bundle, index) => ({
    value: index,
    label: `Bundle ${index + 1} - ${bundle.amount} credits`,
    note: bundle.note,
  }));

  const selectedBundleOptions = bundleOptions.filter((option) =>
    bundleIds.includes(option.value)
  );
  const resetForm = () => {
    setCompanyName("");
    setBillingEnabled(false);
    setAutoRenew(false);
    setAutoRenewThreshold();
    setTrialCredits();
    setInitialCredits();
    setMaxMsisdns();
    setTrialEndDate();
    setBaseConsumption();
    setDefaultBundleId(null);
    setLocalBundles([]);
    setBundleIds([]);
  };

  return (
    <Container className="mt-3">
      <Row className="justify-content-center">
        <Col md={6}>
          <ListComponent
            title={t("pages.companies.title")}
            onPlusClicked={() => {
              resetForm();
              setShowCreateCompany(true);
              // fetchBundles();
            }}
          >
            <Container className="py-2">
              <MenuPopoverWrapper>
                {companies.map((company, i) => {
                  return (
                    <React.Fragment key={company.id}>
                      <Row>
                        <Col>
                          <span>{company.name}</span>
                        </Col>
                        <Col className="d-flex justify-content-end" sm={3}>
                          <Menu placement={"right"}>
                            <MenuItem
                              text={t("global.operations.options")}
                              icon={faUser}
                              onClick={() => setViewAsCompany(company)}
                            />
                            <MenuItem
                              text={t("pages.companies.menu.changeName")}
                              icon={faEdit}
                              onClick={() => {
                                setSelectedCompany(company);
                                setAction("edit");
                                setCompanyName(company.name);
                                setShowChangeNameModal(true);
                              }}
                            />
                            <MenuItem
                              text={t("global.operations.delete")}
                              icon={faTrashCan}
                              variant={"danger"}
                              onClick={() => {
                                setSelectedCompany(company);
                                setAction("delete");
                              }}
                            />
                          </Menu>
                        </Col>
                      </Row>
                      {i < companies.length - 1 && (
                        <hr key={i} style={{ margin: "7px 0px" }} />
                      )}
                    </React.Fragment>
                  );
                })}
              </MenuPopoverWrapper>
            </Container>
          </ListComponent>
        </Col>
      </Row>

      <ActionModal
        func={createCompany}
        active={showCreateCompany}
        hideOnConfirm
        onCancel={() => {
          setShowCreateCompany(false);
        }}
        onConfirm={() => {
          toast.success("Created");
          setShowCreateCompany(null);
          fetchCompanies();
        }}
        title={t("pages.companies.registerCompany")}
        positiveButton={{
          variant: "success",
        }}
      >
        <FormLabel>{t("dialogs.name")}</FormLabel>
        <FormControl
          required
          type="text"
          value={companyName}
          onChange={(e) => {
            setCompanyName(e.target.value);
          }}
        />
        <div className="mt-3">
          <FormLabel>{t("dialogs.createCompanyDialog.billing")}</FormLabel>
        </div>

        <ToggleButtonGroup
          type="radio"
          name="plans"
          value={mode}
          onChange={setMode}
          className="mb-3 mt-1"
        >
          <ToggleButton
            id="tbg-btn-1"
            value="default"
            variant="outline-primary"
          >
            {t("dialogs.modes.default")}
          </ToggleButton>
          <ToggleButton id="tbg-btn-2" value="trial" variant="outline-primary">
            {t("dialogs.modes.trial")}
          </ToggleButton>
          <ToggleButton
            id="tbg-btn-3"
            value="disabled"
            variant="outline-primary"
          >
            {t("dialogs.modes.disabled")}
          </ToggleButton>
        </ToggleButtonGroup>
        {mode == "default" ? (
          <>
            <FormCheck
              id="autoRenew"
              label={t("dialogs.autoRenew")}
              checked={autoRenew}
              onChange={(e) => setAutoRenew(e.target.checked)}
              className="mb-3 mt-1"
            />
            <Form.Label
              htmlFor="autoRenewThreshold"
              className="form-label me-2"
            >
              {t("dialogs.autoRenewThreshold")}
            </Form.Label>
            <InputGroup className="mb-2">
              <Form.Control
                type="number"
                id="autoRenewThreshold"
                min="0"
                value={autoRenewThreshold}
                placeholder="0"
                onChange={(e) => {
                  const value = e.target.value;
                  setAutoRenewThreshold(value === "" ? "" : Number(value));
                }}
              />
              <InputGroup.Text>%</InputGroup.Text>
            </InputGroup>

            <FormLabel>{t("dialogs.initialCredits")}</FormLabel>
            <FormControl
              required
              type="number"
              value={initialCredits}
              placeholder="0"
              onChange={(e) => {
                const value = e.target.value;
                setInitialCredits(value === "" ? "" : Number(value));
              }}
              className="mb-3"
            />

            <FormLabel>{t("dialogs.baseConsumption")}</FormLabel>
            <FormControl
              required
              type="number"
              value={baseConsumption}
              placeholder="0"
              onChange={(e) => {
                const value = e.target.value;
                setBaseConsumption(value === "" ? "" : Number(value));
              }}
              className="mb-3"
            />

            <FormLabel>{t("dialogs.addBundle")}</FormLabel>
            <div className="d-flex align-items-center mb-3 gap-2">
              <input
                type="text"
                value={newBundleCredits}
                onChange={(e) => setNewBundleCredits(e.target.value)}
                className="form-control"
                placeholder={t("creditManagement.enterCredits")}
              />
              <input
                type="text"
                value={newNote}
                onChange={(e) => setNewNote(e.target.value)}
                className="form-control ms-1"
                placeholder={t("creditManagement.enterNote")}
              />
              <i
                className="fas fa-plus text-success"
                style={{ cursor: "pointer", fontSize: "1.25rem" }}
                onClick={() => {
                  if (newBundleCredits.trim()) {
                    const newBundle = {
                      amount: parseInt(newBundleCredits.trim(), 10),
                      active: true,
                    };
                    if (newNote.trim()) {
                      newBundle.note = newNote.trim();
                    }

                    const updated = [...localBundles, newBundle];
                    setLocalBundles(updated);
                    setNewBundleCredits("");
                    setNewNote("");
                  }
                }}
              ></i>
            </div>

            <FormLabel>{t("dialogs.defaultBundleId")}</FormLabel>
            <FormSelect
              value={defaultBundleId ?? ""}
              onChange={(e) => {
                const selectedId = Number(e.target.value);
                setDefaultBundleId(selectedId);
                setBundleIds([selectedId]);
              }}
              className="mb-3"
            >
              <option value="" disabled>
                {t("creditManagement.selectBundle")}
              </option>
              {bundleOptions.map((bundle) => (
                <option key={bundle.value} value={bundle.value}>
                  {bundle.label}
                </option>
              ))}
            </FormSelect>

            <FormLabel>{t("dialogs.availableBundles")}</FormLabel>
            <Select
              isMulti
              isDisabled={!billingEnabled}
              options={bundleOptions}
              value={selectedBundleOptions}
              placeholder={t("creditManagement.select")}
              onChange={(selectedOptions) => {
                const selectedValues = selectedOptions.map(
                  (option) => option.value
                );
                setBundleIds(selectedValues);
              }}
              className="mb-3"
            />
          </>
        ) : mode == "trial" ? (
          <div>
            <FormLabel>{t("dialogs.trialEndDate")}</FormLabel>

            <div className="mb-3">
              <DatePicker
                selected={trialEndDate}
                onChange={(date) => setTrialEndDate(date)}
                dateFormat="dd-MM-yyyy"
                className="form-control"
                minDate={new Date()}
                placeholderText="Select trial end date"
              />
            </div>
            <FormLabel>{t("dialogs.trialCredits")}</FormLabel>
            <FormControl
              required
              type="number"
              value={trialCredits}
              placeholder="0"
              onChange={(e) => {
                const value = e.target.value;
                setTrialCredits(value === "" ? "" : Number(value));
              }}
              className="mb-3"
            />
            <FormLabel>{t("dialogs.maxMsisdns")}</FormLabel>
            <FormControl
              required
              type="number"
              value={maxMsisdns}
              placeholder="0"
              onChange={(e) => {
                const value = e.target.value;
                setMaxMsisdns(value === "" ? "" : Number(value));
              }}
              className="mb-3"
            />
          </div>
        ) : null}
      </ActionModal>

      <ActionModal
        func={onDeleteCompany}
        active={selectedCompany && action === "delete"}
        hideOnConfirm
        onCancel={() => setSelectedCompany(null)}
        onConfirm={() => {
          toast.success("Deleted");
          fetchCompanies();
        }}
        title="Confirm deletion"
      >
        {selectedCompany && (
          <span>
            You are about to <strong style={{ color: "red" }}>delete</strong>{" "}
            <strong>{selectedCompany.name}</strong>. Are you sure you want to
            continue?
          </span>
        )}
      </ActionModal>

      <ActionModal
        active={showChangeNameModal && action === "edit"}
        hideOnConfirm
        func={updateName}
        title={t("pages.companies.menu.changeName")}
        positiveButton={{
          text: t("global.operations.update"),
          variant: "success",
        }}
        onCancel={() => setShowChangeNameModal(false)}
        onConfirm={() => setShowChangeNameModal(false)}
      >
        <FormLabel>{t("dialogs.name")}</FormLabel>
        <FormControl
          required
          type="text"
          value={companyName}
          onChange={(e) => {
            setCompanyName(e.target.value);
          }}
        />
      </ActionModal>
    </Container>
  );
};

export default CompaniesPage;
